import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/dramas';

interface CategoryNavProps {
  active?: string;
}

const CategoryNav = ({ active }: CategoryNavProps) => {
  const handleClick = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="flex flex-wrap items-center gap-2">
      {categories.map((cat) => (
        <Link
          key={cat}
          to={`/category/${encodeURIComponent(cat)}`}
          onClick={handleClick}
          className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
            active === cat
              ? 'bg-primary-500 text-background-50'
              : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-800'
          }`}
        >
          {cat}
        </Link>
      ))}
    </div>
  );
};

export default CategoryNav;